/**
 * Multi Select Component ToolTip Filter
 * q-select 다중 선택에 대한 label filter
 *
 * @since 2018-07-24
 * @author kdydesign.kim
 */

import {i18n} from '../plugins/i18n'

export default function multiSelectFilter (val, opts) {
  const arr = []

  _.each(val, (v) => {
    arr.push(_.filter(opts, {'value': v}))
  })

  const fullStr = _.join(_.map(_.flatten(arr), 'label'), ', ')

  return fullStr === '' ? i18n.t('cmn.noCondition') : fullStr
}
